import { createContext } from 'react';

import { LocaleContextType } from './localeContext.types';

export const LocaleContext = createContext<LocaleContextType | undefined>(undefined);
